module.exports = __webpack_public_path__ + "static/media/Communikey-Logo.a683e413.svg";